// app/javascript/controllers/ats_template_picker_controller.js
import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "ats-optimizer-template"

export default class extends Controller {
  static targets = ["templateCard", "pageSizePill"]
  static values = {
    template: { type: String, default: "classic" },
    pageSize: { type: String, default: "A4" }
  }

  connect() {
    this.#restore()
    this.#applyTemplateActive()
    this.#applyPageSizeActive()
  }

  selectTemplate(event) {
    const id = event.currentTarget.dataset.template
    if (!id) return
    this.templateValue = id
  }

  selectPageSize(event) {
    const size = event.currentTarget.dataset.pageSize
    if (!size) return
    this.pageSizeValue = size
  }

  templateValueChanged() {
    this.#applyTemplateActive()
    this.#persist()
    this.dispatch("template-changed", {
      detail: { template: this.templateValue, pageSize: this.pageSizeValue },
      prefix: "ats-optimizer"
    })
  }

  pageSizeValueChanged() {
    this.#applyPageSizeActive()
    this.#persist()
    this.dispatch("template-changed", {
      detail: { template: this.templateValue, pageSize: this.pageSizeValue },
      prefix: "ats-optimizer"
    })
  }

  #applyTemplateActive() {
    for (const el of this.templateCardTargets) {
      const active = el.dataset.template === this.templateValue
      el.classList.toggle("border-2", active)
      el.classList.toggle("border-primary", active)
      el.classList.toggle("bg-primary-fixed/5", active)
      el.classList.toggle("border-border-light", !active)
      el.classList.toggle("hover:border-primary/50", !active)
      const label = el.querySelector("p")
      if (label) {
        label.classList.toggle("text-primary", active)
        label.classList.toggle("text-on-surface", !active)
      }
    }
  }

  #applyPageSizeActive() {
    for (const el of this.pageSizePillTargets) {
      el.dataset.active = (el.dataset.pageSize === this.pageSizeValue) ? "true" : "false"
    }
  }

  #persist() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        template: this.templateValue,
        pageSize: this.pageSizeValue
      }))
    } catch (_e) {}
  }

  #restore() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY)
      if (!raw) return
      const { template, pageSize } = JSON.parse(raw)
      if (template) this.templateValue = template
      if (pageSize) this.pageSizeValue = pageSize
    } catch (_e) {}
  }
}
